import { join, resolve } from 'path';
import { sessionPlayerLoggerFormatter } from './logger';

export const options: { playerPath: string | undefined } = { playerPath: undefined };

let sessionPlayerInit: import('clickim/src/background/sessionPlayerInit').SessionPlayerInit | undefined;

export const getSessionPlayer = () => {
    if (sessionPlayerInit) {
        return sessionPlayerInit;
    }
    const perf = require('./performance-logger') as typeof import('./performance-logger');

    perf.log('getSessionPlayerRequire start');
    const { getSessionPlayerFolder } = require('./prepareRunnerAndTestimStartUtils') as typeof import('./prepareRunnerAndTestimStartUtils');

    const testimAppDataFolder = getSessionPlayerFolder();
    const path = options.playerPath ? resolve(options.playerPath, 'src/background/sessionPlayerInit.ts') : join(testimAppDataFolder, 'sessionPlayer.js');

    const sessionPlayer = require(path) as import('clickim/src/background/sessionPlayerInit').SessionPlayerInit; // eslint-disable-line import/no-dynamic-require

    perf.log('getSessionPlayerRequire end');
    sessionPlayerInit = sessionPlayer;
    if (process.env.LOGGER_CONSOLE && process.env.DEBUG && sessionPlayer.setLoggerFormatter) {
        sessionPlayer.setLoggerFormatter(sessionPlayerLoggerFormatter);
    }
    return sessionPlayer;
};
